var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 74,
    viewBox: "0 0 84 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0985 14.8711C67.8985 10.108 57.4129 12.9384 52.6742 21.1897L40.729 42.0115C37.2726 48.0242 41.7222 50.1252 46.6839 53.1186L58.178 59.7941C62.0703 62.0533 67.042 60.7121 69.2872 56.8006L81.5669 35.4024C85.6922 28.2119 83.2444 19.0224 76.0985 14.8711Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5826 23.4894L51.0885 16.814C44.7434 13.2697 41.1502 13.0351 38.5451 17.2016L21.5928 46.744C16.8592 54.9902 19.677 65.5363 27.8719 70.2892C35.0178 74.4403 44.1504 71.9771 48.2757 64.7866L65.5525 34.6729C67.8077 30.7565 66.4749 25.7486 62.5826 23.4894Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7947 8.30274L56.7214 3.61105C47.7916 -1.57533 36.3735 1.49977 31.2193 10.4854L15.848 37.2739C13.5776 41.2262 14.9257 46.285 18.8534 48.5646L27.8947 53.8173C32.3595 56.4131 38.0661 54.8729 40.6458 50.3801L58.2063 19.7771C61.8452 13.4381 69.8982 11.2656 76.1977 14.9272L64.7947 8.30274Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4032 18.15L24.6761 13.0911C20.7838 10.8371 15.8122 12.1732 13.5671 16.0795L3.09662 34.2854C-2.05755 43.2454 0.998459 54.7096 9.92827 59.8807L16.5724 63.7308L24.6305 68.4021L28.1274 70.4267C21.9191 66.2451 19.9477 57.8662 23.7436 51.2672L26.4549 46.5551L36.3832 29.2927C38.6232 25.3967 37.2904 20.404 33.4032 18.15Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.1be2360d3ebed5a07d9b26fc60c5bff1.svg";
export { ForwardRef as ReactComponent };